import * as React from 'react';
import { useState, useEffect } from 'react';
import Select from 'react-select';
import { CPProblemSearchRequest } from '../apimodels/CPProblemSearch';
import { CPOwnerSetting } from '../enums/CPOwnerSetting';
import { CPProblemSummary } from '../models/CPProblemSummary';
import { Range, getTrackBackground } from "react-range";
import { CPReactMethods } from '../app';
import { RetireProblemRequest } from '../apimodels/RetireProblemRequest'
import RetireProblemModalComponent from './RetireProblemModalComponent';
import { Collapse } from 'react-bootstrap';

export interface ProblemSearchComponentProps {
    addNewProblems?: Function
    setIsAddingProblem?: Function
    isProblemLibrary: boolean,
    selectedTopic?: string,
}

const ProblemSearchComponent = (props: ProblemSearchComponentProps) => {
    const [problems, setProblems] = useState<Array<CPProblemSummary>>([])
    const [selectedTags, setSelectedTags] = useState<Array<{ label: string, value: string }>>([])
    const [tagOptions, setTagOptions] = useState<Array<{ label: string, value: string }>>([])
    const [topics, setTopics] = useState<Array<{ label: string, value: { codename: string, guid: string } }>>([])
    const [selectedTopic, setSelectedTopic] = useState<{ label: string, value: { codename: string, guid: string } } | undefined>(props.selectedTopic ? { label: "", value: { codename: props.selectedTopic, guid: "" } } : undefined)
    const [searchText, setSearchText] = useState("")
    const [problemOwnerType, setProblemOwnerType] = useState(props.isProblemLibrary ? CPOwnerSetting.Mine : CPOwnerSetting.Public)
    const [selectedDifficulties, setSelectedDifficulties] = useState([1, 5])
    const [searched, setSearched] = useState(false)
    const [isSearching, setIsSearching] = useState(false)
    const [retireProblemId, setRetireProblemId] = useState<number | undefined>()
    const [selectedProblems, setSelectedProblems] = useState<Array<CPProblemSummary>>([])
    const [hideSelectedProblems, setHideSelectedProblems] = useState(false)
    const [addingProblem, setAddingProblem] = useState(false)


    useEffect(() => {
        window.CPInstructor.getProblemTags().then(response => {
            var formattedTags: Array<{ label: string, value: string }> = []
            response.forEach(t => {
                formattedTags.push({ label: t, value: t })
            })
            setTagOptions(formattedTags)
        })
        window.CPInstructor.getProblemTopics().then(response => {
            var formattedTopics: Array<{ label: string, value: { codename: string, guid: string } }> = []
            formattedTopics = response
            setTopics(formattedTopics);
            if (props.selectedTopic) {
                setSelectedTopic(formattedTopics.find(topic => topic.value.codename == props.selectedTopic))
            }
            if (props.isProblemLibrary) {
                search()
            }
        })
    }, [])

    const search = () => {
        try {
            setIsSearching(true)
            var formattedTags: Array<string> = [];
            selectedTags.forEach(tag => formattedTags.push(tag.value.replace(/'/g, "''")))
            var topic = ""
            if (selectedTopic) {
                topic = selectedTopic.value.codename
            }
            var request: CPProblemSearchRequest = {
                lookupValue: searchText,
                ownerSetting: problemOwnerType,
                tags: formattedTags,
                topicValue: topic,
                difficultyMax: selectedDifficulties[1] > selectedDifficulties[0] ? selectedDifficulties[1] : selectedDifficulties[0],
                difficultyMin: selectedDifficulties[0] < selectedDifficulties[1] ? selectedDifficulties[0] : selectedDifficulties[1],
            }
            window.CPInstructor.findProblems(request)
                .then(response => {
                    setProblems(response.problems)
                    setSearched(true)
                })
                .catch((error) => {

                }).finally(() => {
                    setIsSearching(false)
                })
        }
        catch (error) {
            setIsSearching(false)
        }
    }

    const searchGivenTag = (tag: string) => {
        try {
            setIsSearching(true)
            var formattedTags: Array<string> = [];
            formattedTags.push(tag.replace(/'/g, "''"))
            var request: CPProblemSearchRequest = {
                lookupValue: searchText,
                ownerSetting: problemOwnerType,
                tags: formattedTags,
                difficultyMax: selectedDifficulties[1] > selectedDifficulties[0] ? selectedDifficulties[1] : selectedDifficulties[0],
                difficultyMin: selectedDifficulties[0] < selectedDifficulties[1] ? selectedDifficulties[0] : selectedDifficulties[1],
            }
            window.CPInstructor.findProblems(request)
                .then(response => {
                    setProblems(response.problems)
                    setSearched(true)
                }).catch((error) => {
                }).finally(() => {
                    setIsSearching(false)
                })
        }
        catch (error) {
            setIsSearching(false)
        }
    }

    const searchGivenDifficulty = (difficulty: number) => {
        try {
            setIsSearching(true)
            var formattedTags: Array<string> = [];
            selectedTags.forEach(tag => formattedTags.push(tag.value.replace(/'/g, "''")))
            var request: CPProblemSearchRequest = {
                lookupValue: searchText,
                ownerSetting: problemOwnerType,
                tags: formattedTags,
                difficultyMax: difficulty,
                difficultyMin: difficulty,
            }
            window.CPInstructor.findProblems(request)
                .then(response => {
                    setProblems(response.problems)
                    setSearched(true)
                })
                .catch((error) => {

                }).finally(() => {
                    setIsSearching(false)
                })
        }
        catch (error) {
            setIsSearching(false)
        }
    }

    const selectTag = tag => {
        var updatedSelectedTags = { "value": tag, "label": tag }
        setSelectedTags([updatedSelectedTags])
        searchGivenTag(tag)
    }

    const selectDifficulty = (difficulty: number) => {
        var updatedSelectedDifficulties = [difficulty, difficulty]
        // @ts-ignore
        setSelectedDifficulties(updatedSelectedDifficulties)
        searchGivenDifficulty(difficulty)
    }

    const selectTopic = topic => {
        var updatedSelectedTopic = { "value": topic, "label": topic }
        // @ts-ignore
        setSelectedTopic(updatedSelectedTopic)
        setSelectedTags([])
    }

    const changeTagSelect = selectedOptions => {
        setSelectedTags(selectedOptions)
    }

    const changeTopic = selectedOption => {
        setSelectedTopic(selectedOption)
    }

    /*getPageProblems = (problems, page) => {
      return problems.slice(0 + (page -1)*10, page*10)
      
    }*/

    const retireProblem = (problemId: number, reason: string) => {
        var request: RetireProblemRequest = {
            problemId: problemId,
            reason: reason
        }
        window.CPInstructor.retireProblem(request).then(response => {
            if (response) {
                var updatedProblems = [...problems]
                var problemIndex = updatedProblems.findIndex(problem => problem.problemId == problemId)
                updatedProblems.splice(problemIndex, 1)
                setProblems(updatedProblems)
                setRetireProblemId(undefined)
            }
        })
    }

    const cloneProblem = (problemId: number) => {
        window.CPInstructor.cloneProblem(problemId).then(response => {
            if (response) {
                window.location.href = "/calcpad/problem/edit/" + response.data.guid
            }
        })
    }

    const addToSelectedProblems = (problem: CPProblemSummary) => {
        var newSelectedProblems = [...selectedProblems]
        newSelectedProblems.push(problem)
        setSelectedProblems(newSelectedProblems)
    }

    const selectedProblemsToGuidArray = (): Array<string> => {
        var guidArray: Array<string> = []
        selectedProblems.forEach(problem => {
            guidArray.push(problem.problemGuid)
        })
        return guidArray
    }

    const removeSelectedProblem = (index: number) => {
        var updatedSelectedProblems = [...selectedProblems]
        updatedSelectedProblems.splice(index, 1)
        setSelectedProblems(updatedSelectedProblems)
    }

    return (
        <div className={isSearching ? "container-fluid busy" : "container-fluid"}>
            <div className="row">
                <div className="col">
                    {!props.isProblemLibrary ?
                        <button type="button" className="btn btn-outline-primary my-2" onClick={e => props.setIsAddingProblem!(false)}>Back</button>
                        : <a href={"/calcpad/problem/new/" + (selectedTopic != undefined && selectedTopic != null ? selectedTopic.value.guid : "")} ><button type="button" className="btn btn-primary my-2">New Problem</button></a>
                    }
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <label><b>Text or ID</b></label>
                </div>
            </div>
            <input type="text" value={searchText} className="form-control" placeholder="Search..." onChange={e => setSearchText(e.currentTarget.value)} />
            <label><b>Problem Owner</b></label>
            <Select
                name="OwnerType"
                onChange={e => setProblemOwnerType(e!.value || CPOwnerSetting.All)}
                value={{ label: CPOwnerSetting[problemOwnerType], value: problemOwnerType }}
                options={[{ label: CPOwnerSetting[CPOwnerSetting.All], value: CPOwnerSetting.All },
                { label: CPOwnerSetting[CPOwnerSetting.Mine], value: CPOwnerSetting.Mine },
                { label: CPOwnerSetting[CPOwnerSetting.Public], value: CPOwnerSetting.Public },
                { label: CPOwnerSetting[CPOwnerSetting.Subscription], value: CPOwnerSetting.Subscription }]}
                placeholder="Select Problem Owner"
            />
            <label><b>Topics</b></label>
            <Select
                name="Topics"
                onChange={changeTopic}
                value={selectedTopic}
                isClearable={true}
                // @ts-ignore
                options={topics}
                className="basic-single"
                classNamePrefix="select"
                placeholder="Select Topic"
            />
            <label><b>Tags</b></label>
            <Select
                isMulti
                name="tags"
                onChange={changeTagSelect}
                // @ts-ignore
                options={tagOptions}
                value={selectedTags}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select Tags..."
            />
            <label><b>Difficulty</b></label>
            <Range
                allowOverlap
                values={selectedDifficulties}
                step={1}
                min={1}
                max={5}
                onChange={values => setSelectedDifficulties(values)}
                renderMark={({ props, index }) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            height: "16px",
                            width: "5px",
                            backgroundColor: (index >= selectedDifficulties[0] - 1 && index <= selectedDifficulties[1] - 1) || (index >= selectedDifficulties[1] - 1 && index <= selectedDifficulties[0] - 1) ? "#000" : "#AAA"
                        }}
                    >
                        <div className="text-center" style={{ marginTop: "30px", width: "100px", transform: "translateX(-50%)" }}>
                            {index == 0 ? "Very Easy" : index == 1 ? "Easy" : index == 2 ? "Medium" : index == 3 ? "Hard" : "Very Hard"}
                        </div>
                    </div>
                )}
                renderTrack={({ props, children }) => (
                    <div
                        onMouseDown={props.onMouseDown}
                        onTouchStart={props.onTouchStart}
                        style={{
                            ...props.style,
                            height: "90px",
                            display: "flex",
                            margin: "-1% auto auto auto",
                            width: "80%"
                        }}
                    >
                        <div
                            ref={props.ref}
                            style={{
                                height: "5px",
                                width: "100%",
                                borderRadius: "4px",
                                background: getTrackBackground({
                                    values: selectedDifficulties,
                                    colors: ["#aaa", "#000", "#aaa"],
                                    min: 1,
                                    max: 5
                                }),
                                alignSelf: "center"
                            }}
                        >
                            {children}
                        </div>
                    </div>
                )}
                renderThumb={({ props, isDragged, index }) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            height: "42px",
                            width: "42px",
                            borderRadius: "21px",
                            backgroundColor: "#FFF",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            boxShadow: "0px 2px 6px #AAA"
                        }}
                    >
                        <div
                            style={{
                                height: "16px",
                                width: "5px",
                                backgroundColor: "#000"
                            }}
                        />
                    </div>
                )}
            />
            <button type="button" className="btn btn-primary" onClick={() => search()}>{isSearching ? "Searching" : "Search"}</button>

            {
                problems.map(problem => {
                    return (
                        <div className="card my-3" key={problem.problemGuid}>
                            <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <b>{problem.problemName}</b>
                                    </div>
                                    {props.isProblemLibrary ?
                                        problem.owner == CPOwnerSetting.Mine ?
                                            <>
                                                <div className="col-auto">
                                                    <a className="text-link" onClick={() => window.location.href = "/calcpad/problem/edit/" + problem.problemGuid}>
                                                        <b>Edit Problem</b>
                                                    </a>
                                                </div>
                                                <div className="col-auto">
                                                    <a className="text-link" data-bs-toggle="modal" data-bs-target="#DeleteProblemModal" onClick={() => setRetireProblemId(problem.problemId)}>
                                                        <b>Delete Problem</b>
                                                    </a>
                                                </div>
                                            </> :
                                            <div className="col-auto">
                                                <a className="text-link" onClick={() => cloneProblem(problem.problemId)}>
                                                    <b>Clone Problem</b>
                                                </a>
                                            </div>
                                        :
                                        <div className="col-auto">
                                            <a className="text-link" onClick={() => addToSelectedProblems!(problem)}>
                                                <b>Select Problem</b>
                                            </a>
                                        </div>
                                    }
                                </div>
                                <div className="row">
                                    {problem.difficulty ?
                                        <div className="col-auto">
                                            Difficulty: &nbsp;
                                            <a className="text-link" onClick={() => selectDifficulty(problem.difficulty!)}>
                                                {problem.difficulty == 1 ? "Very Easy" : problem.difficulty == 2 ? "Easy" : problem.difficulty == 3 ? "Medium" : problem.difficulty == 4 ? "Hard" : problem.difficulty == 5 ? "Very Hard" : ""}
                                            </a>
                                        </div> : ""}
                                    {problem.topic ?
                                        <div className="col-auto">
                                            Topic: &nbsp;
                                            <a className="text-link">
                                                {problem.topic}
                                            </a>
                                        </div> : ""
                                    }
                                    <div className="col-auto">
                                        Id: {problem.problemGuid}
                                    </div>
                                </div>
                            </div>
                            <div className="row align-items-center">
                                <div className="col">
                                    <div className="card-body">
                                        <div className="row align-items-center">
                                            <div className="card-title">
                                                <div dangerouslySetInnerHTML={{ __html: problem.text }}></div>
                                            </div>
                                        </div>
                                        <ol className="partList" type="a">
                                            {problem.parts.map((part, partIndex) => {
                                                return (
                                                    <li style={{ listStyle: problem.parts.length <= 1 ? "none" : "" }} key={partIndex}>
                                                        <div className="row">
                                                            <div dangerouslySetInnerHTML={{ __html: part.text }} />
                                                        </div>
                                                        <div className="row">
                                                            {part.multipleChoice ?
                                                                <>
                                                                    <div className="col-auto">
                                                                        {part.answerLabel}
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        {part.options ?
                                                                            part.options.map((option, optionIndex) => {
                                                                                return (
                                                                                    <div className="form-check" key={optionIndex}>
                                                                                        <input className="form-check-input" type="radio" checked={false} onChange={() => { }} />
                                                                                        <label className="form-check-label">{option.text}</label>
                                                                                    </div>
                                                                                )
                                                                            }) : ""}
                                                                    </div>
                                                                    <div className="col-auto">
                                                                        {part.unitsLabel}
                                                                    </div>
                                                                </>
                                                                /* Creates a select box
                                                                <select className="form-select" value={answers[problemIndex].parts[partIndex].attempts[answers[problemIndex].parts[partIndex].attempts.length - 1].answer} onChange={e => changeAnswer(problemIndex, partIndex, e.currentTarget.value)}>
                                                                    {part.options.map(option => {
                                                                        return (
                                                                            <option key={option.text} value={option.value}>{option.text}</option>
                                                                        )
                                                                    })}
                                                                </select>*/

                                                                :
                                                                <div className="col-auto">
                                                                    <div className="input-group mb-3">
                                                                        {!CPReactMethods.isNullOrWhiteSpace(part.answerLabel) ?
                                                                            <span className="input-group-text px-1">
                                                                                <p className="mb-0" dangerouslySetInnerHTML={{ __html: part.answerLabel }}>
                                                                                </p>
                                                                            </span> : ""}
                                                                        <input type="text" className="form-control w-25" value="" onChange={() => { }} />
                                                                        {part.scientificNotation ?
                                                                            <>
                                                                                <span className="input-group-text px-1">
                                                                                    x10^
                                                                                </span>
                                                                                <input type="text" className="form-control" value="" onChange={() => { }} />
                                                                            </> : ""}
                                                                        {!CPReactMethods.isNullOrWhiteSpace(part.unitsLabel) ?
                                                                            <span className="input-group-text px-1">
                                                                                <p className="mb-0" dangerouslySetInnerHTML={{ __html: part.unitsLabel }}>
                                                                                </p>
                                                                            </span> : ""}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </li>
                                                )
                                            })}
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            {problem.tags.length > 0 ?
                                <div className="card-footer">
                                    Tags: &nbsp;
                                    {problem.tags.map((tag, tagIndex) => {
                                        return (
                                            <button type="button" className="btn btn-sm btn-primary m-1" key={tag} onClick={() => selectTag(tag)}>
                                                {tag}
                                            </button>
                                        )
                                    })}
                                </div> : ""}
                        </div>
                    )
                })
            }
            {problems.length == 0 && searched ? <h2>No results are found</h2> : ""}
            {
                props.isProblemLibrary ?
                    <RetireProblemModalComponent
                        itemId={'DeleteProblemModal'}
                        problemId={retireProblemId ?? 0}
                        buttonFunction={retireProblem}
                    /> : ""
            }
            {selectedProblems.length > 0 ?
                <div className="row fixed-bottom force-z-top justify-content-end">
                    <div className="col col-sm-8 col-md-6 col-lg-4">
                        <div className="card selectedProblemsCard">
                            <div className="card-header" style={{ cursor: 'pointer' }} onClick={() => setHideSelectedProblems(!hideSelectedProblems)}>
                                <div className="row align-items-center">
                                    <div className="col">
                                        {selectedProblems.length} {selectedProblems.length > 1 ? "Problems" : "Problem"} Selected
                                    </div>
                                    <div className="col-auto">
                                        <button type="button" className="btn btn-primary" disabled={addingProblem} onClick={() => props.addNewProblems!(selectedProblemsToGuidArray())}>{selectedProblems.length > 1 ? "Add Problems" : "Add Problem"}</button>
                                    </div>
                                </div>
                            </div>
                            <Collapse in={!hideSelectedProblems}>
                                <ul className="list-group list-group-flush">
                                    {selectedProblems.map((problem, index) => {
                                        return (
                                            <li key={problem.problemGuid + index} className="list-group-item problem-select-list-item">
                                                <div className="row">
                                                    <div className="col">
                                                        {problem.problemName}
                                                    </div>
                                                    <div className="col-auto">
                                                        <a className="text-link" onClick={() => removeSelectedProblem(index)} >
                                                            <b>Deselect</b>
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </Collapse>
                        </div>
                    </div>
                </div>
                : ""
            }
        </div >
    )
}

export default ProblemSearchComponent;